import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withComponentInputBinding, withRouterConfig } from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";

import { StoreAuthModule } from "@/app/stores/auth/store-auth.module";
import { environment } from "@environments/environment";
import { registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import en from "@angular/common/locales/en";
import { FormsModule } from "@angular/forms";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  ArrowRightOutline,
  LoadingOutline,
  LogoutOutline,
  PlusOutline,
  SyncOutline,
  UserOutline,
  LockOutline,
  FileTextOutline,
  DashboardOutline,
  InstagramOutline,
  FacebookOutline,
  LinkedinOutline,
  TwitterOutline,
  PlayCircleOutline,
  MenuOutline,
  SendOutline,
  FilterOutline,
  AlertOutline,
  WarningOutline,
  MailOutline,
  ThunderboltOutline,
} from "@ant-design/icons-angular/icons";
import { AuthModule } from "@auth0/auth0-angular";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { en_US, provideNzI18n } from "ng-zorro-antd/i18n";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzNotificationModule } from "ng-zorro-antd/notification";
import { routes } from "./app.routes";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { providePostHogErrorHandler, providePostHogPageviewTracking } from "@handshake/core-fe";

registerLocaleData(en);

const icons = [
  ArrowRightOutline,
  LoadingOutline,
  SyncOutline,
  LogoutOutline,
  PlusOutline,
  UserOutline,
  LockOutline,
  FileTextOutline,
  DashboardOutline,
  InstagramOutline,
  FacebookOutline,
  LinkedinOutline,
  TwitterOutline,
  MenuOutline,
  PlayCircleOutline,
  SendOutline,
  FilterOutline,
  AlertOutline,
  WarningOutline,
  MailOutline,
  ThunderboltOutline,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: "always" })),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule, NzNotificationModule, StoreModule.forRoot([]), EffectsModule.forRoot([]), StoreAuthModule),
    provideAnimationsAsync(),
    provideHttpClient(),
    importProvidersFrom(NzModalModule),
    importProvidersFrom(
      AuthModule.forRoot({
        domain: environment.auth0.domain,
        clientId: environment.auth0.clientId,
        authorizationParams: {
          redirect_uri: window.location.origin + "/callback",
          audience: environment.auth0.audience,
          scope: "openid profile email",
        },

        useRefreshTokens: true,
        cacheLocation: "localstorage",
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(NzIconModule.forRoot(icons)),
    provideServiceWorker("ngsw-worker.js", {
      enabled: true,
      registrationStrategy: "registerWhenStable:30000",
    }),
    providePostHogErrorHandler(),
    providePostHogPageviewTracking(),
  ],
};
